import { setResponse } from 'Core/actions/response.ts';
import { tryResponseRedirect } from 'Core/epics/redirect.js';
import { searchPreselectionSelector } from 'Core/selectors/preselection.js';
import { abortControllerCreator, search } from 'Modules/serverApi/index.js';

const createAbortController = abortControllerCreator();

export default function sendRequest(arg, request) {
  const {
    state,
    dispatch,
    action: { onInit, meta: { extra = {}, responseMeta = {} } = {} },
  } = arg;

  const preselection = searchPreselectionSelector(state);
  const selection = [...request.selection, ...preselection];

  const req = { ...request, selection, extra };

  search(req, createAbortController())
    .then((response) => {
      if (response.State === 'cancelled') {
        return;
      }

      if (tryResponseRedirect(arg, response)) {
        // Don't visually change the search results on the page if there is a redirect,
        // but dispatch Fitment Search action to ensure a vehicle is selected before redirect
        return;
      }

      dispatch(
        setResponse(response, {
          appendItems: request.action === 'add',
          preselection,
          onInit,
          ...responseMeta,
        }),
      );
    })
    .catch(console.warn);
}
